module.exports = require('./helpers/bundle-url').getBundleURL('UckoE') + "carousel-arrow-right.ed4476c5.png" + "?" + Date.now();